<template>
  <div>
    <SSubHeader :pageName="getPageName" :backButton="true"/>
    <div class="header-spacer"></div>
    <div :key="pageKey">
      <SPreloader />
      <HeaderProfile :userProfile="user"/>
      <div class="container d-flex flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row">
        <div class="left-bar col col-lg-3 col-xl-3 no-padding" v-if="showProfile" >
          <ProfileAboutMe :about="user"/>
        </div>
        <!-- ROUTER CONTAINER -->

        <div class="profile-feed">
          <ProfileCategories
            v-if="this.$route.name === 'InventoryProfileItems'"
            class="category-buttons"
            :categories="categories"
            @categoryButton="makeFilter"
            :userInfo="user"
          />
          <div class="d-flex w-100 justify-content-between right-space">
            <LoadingSpinner position="relative" v-if="isLoading"/>
            <router-view v-if="!isLoading" 
              :key="componentKey" 
              :userProfile="user" 
              :items="timeLine" 
              :filter="categoryFilter" 
              @updateFavList="updateFavList">
            </router-view>
          </div>
        </div>

      </div>
      <div>
        <a class="back-to-top arrow-top" href="#" v-if="pageBottom">
          <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
        </a>
      </div>
    </div>
    <Modal
      id="share-inventory-modal"
      title="Share your inventory"
      ref="modal"
    >
      <h5 class="login-text">Copy and share this link with your friends</h5>
      <ShareInventory></ShareInventory>
    </Modal>
    <Footer/>
  </div>
</template>
<script>
import HeaderProfile from "@/components/organisms/HeaderProfile";
import UserHelper from "../mixins/UserHelper";
import store from "@/vuex/store";
import SPreloader from "@/components/organisms/SPreloader.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import ProfileAboutMe from '../components/molecules/ProfileAboutMe.vue';
import ProfileCategories from "@/material-components/molecules/ProfileCategories.vue";
import ShareInventory from "@/material-components/molecules/ShareInventory.vue";
import Footer from "@/templates/Footer";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
// import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import Modal from "@/components/atoms/Modal.vue";
import Global from "@/constants/Global";

export default {
  name: "ProfilePage",
  data() {
    return {
      pageKey: 0,
      componentKey: 0,
      isLoading: false,
      showProfile: false,
      copyText: "Copy",
      frontUrl: Global.getFrontDomain(),
      categories: [
        {
          name: "free",
          categoryId: 13,
          icon: "sell",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/free?filter=13",
        },
        {
          name: "book",
          categoryId: 8,
          icon: "book",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/book?filter=8",
        },
        {
          name: "auto",
          categoryId: 5,
          icon: "directions_car",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/auto?filter=5",
        },
        {
          name: "clothing",
          categoryId: 3,
          icon: "checkroom",
          iconClass: "material-icons clothing-class",
          searchQuery: "/s-app/search-result/clothing?filter=3",
        },
        {
          name: "electronic",
          categoryId: 2,
          icon: "phone_android",
          iconClass: "material-icons electronic-class",
          searchQuery: "/s-app/search-result/electronic?filter=2",
        },
        {
          name: "family",
          categoryId: 9,
          icon: "child_friendly",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/family?filter=9",
        },
        {
          name: "games",
          categoryId: 10,
          icon: "sports_esports",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/games?filter=10",
        },
        {
          name: "household",
          categoryId: 1,
          icon: "maps_home_work",
          iconClass: "material-icons-outlined household-class",
          searchQuery: "/s-app/search-result/household?filter=1",
        },
        {
          name: "music",
          categoryId: 4,
          icon: "library_music",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/music?filter=4",
        },
        {
          name: "sports",
          categoryId: 11,
          icon: "sports_football",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/sports?filter=11",
        },
        {
          name: "tools",
          categoryId: 12,
          icon: "build",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/tools?filter=12",
        },
        {
          name: "video",
          categoryId: 6,
          icon: "duo",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/video?filter=6",
        },
        {
          name: "other",
          categoryId: 7,
          icon: "more_horiz",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/other?filter=7",
        },
      ],
      categoryFilter: {}
    };
  },
  components: {
    HeaderProfile,
    SPreloader,
    SSubHeader,
    ProfileCategories,
    ShareInventory,
    Footer,
    LoadingSpinner,
    // SButtonMaterial,
    Modal,
    ProfileAboutMe
},
  mixins: [UserHelper],
  computed: {
    shareLink() {
      // return `${this.frontUrl}/signup?code=${this.loggedUser.inviteCode}`;
      return (Global.getFrontDomain() + "/" + this.user.username + "/inventory");
    },
    timeLine() {
      if (!Array.isArray(this.profileTimeline)) {
        return;
      }
      const timeline = [...this.profileTimeline];
      timeline.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      return timeline.filter((element) => !element.groupId);
    },
    getPageName() {
      return this.user.id === this.loggedUser.id
        ? "My profile"
        : "User profile";
    },
  },
  methods: {
    makeFilter(value){
      if (value !== null) {
        this.categoryFilter = value
      } else {
        this.categoryFilter = {}
      }
    },
    onCopy() {
      this.copyText = "Copied!";
    },
    setupProfilePage() {
      this.fetchUserProfile(this.$route.params.id);
      this.fetchProfileItems(this.$route.params.id);
      this.fetchProfileGroups(this.$route.params.id);
    },
    updateFavList() {
      this.isLoading = true;
      setTimeout(() => {
        this.componentKey += 1;
        this.isLoading = false;
      }, 500);

    },
    openShareModal() {
      $("#share-inventory-modal").modal("show");
    },
    handleResize() {
      this.showProfile = window.innerWidth > 1024;
    },
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("fetchUserProfile", to.params.id);
    const isUserActived = store.getters["getUserProfile"].activated;
    if (isUserActived === 1) {
      await store.dispatch("fetchProfileItems", to.params.id);
      await store.dispatch("fetchProfileGroups", to.params.id);
      await store.dispatch("getMyGroups", to.params.id);
      const myGroups = store.getters["getMyGroups"];
      await store.dispatch("fetchMembershipsProfile", myGroups);
      next();
    } else {
      next("/s-app/feed");
    }
  },
  watch: {
    $route(to, from) {
      if (to.params !== from.params) this.setupProfilePage();
    },
  },
  mounted() {
    this.showProfile = window.innerWidth > 1024;
    window.addEventListener('resize', this.handleResize);
    // this.shareLink = Global.getFrontDomain() + "/" + this.user.username + "/inventory";
  },
};
</script>

<style lang="scss" scoped>
  .update-btn {
    display: flex;
    justify-content: right;
    flex: 25%;
    max-width: 100%;
  }
  .update-btn button {
    width: 175px;
    padding: 1rem 1rem;
  }
</style>

<style lang="scss" scoped>
.user-avatar {
  width: 100% !important;
  height: 100% !important;
}
.container {
  max-width: 1628px;
  padding: 0 32px;
  margin: auto !important;
}
.profile-feed {
  max-width: 85%;
  min-width: 85%;
}
.category-buttons {
  max-width: 100%;
}
.right-space {
  flex-direction: column;
  height: 100%;
}
.left-bar {
  flex: unset;
  margin-right: 8px;
  min-width: 224px;
  max-width: 224px;
}
.share-input-design {
  display: flex;
  align-items: center;
  border: 1px solid gray;
  border-radius: 10px;
}
.share-link {
  border: none;
}
.copy-button {
  width: 15%;
  cursor: pointer;
  color: #05919B;
}
@media screen and (max-width: 1024px) {
  .profile-feed {
    max-width: 100%;
    min-width: 100%;
  }
}
@media screen and (min-width: 1024px) {
  .justify-content-between {
    width: 85% !important;
  }

  .container {
  padding: 0 64px;
}
}
</style>
